import React, { createContext, useEffect, useState } from "react";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  // Vous pouvez éventuellement récupérer l'utilisateur à partir du stockage local
  useEffect(() => {
    const savedUser = JSON.parse(localStorage.getItem("user")); // Ajustez selon vos besoins
    if (savedUser) {
      setUser(savedUser);
    }
  }, []);

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};
